import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { TokenResult } from "../domain/entities/Main";
import { usePopup } from "../../../shared/hooks/usePopup";
import MainUseCase from "../domain/usecases/MainUseCase";
import MainApi from "../data/MainApi";

export function useFaq(tokenResponse: TokenResult | null | undefined) {
  const { showPopup, handleErrorResponse } = usePopup();

  const repository = new MainUseCase(new MainApi());
  const {
    data: faqResponse,
    error,
    isError,
  } = useQuery({
    refetchOnWindowFocus: false,
    enabled: !!tokenResponse?.partnerId,
    retry: false,
    queryKey: ["faq", tokenResponse],
    queryFn: () => repository.getFaq(tokenResponse?.partnerId as string),
  });

  useEffect(() => {
    if (error && error instanceof AxiosError && isError) {
      handleErrorResponse(error);
    }
  }, [error, isError]);

  return { faqResponse };
}
